import { render, staticRenderFns } from "./instructionRelease.vue?vue&type=template&id=76ae51cf&scoped=true"
import script from "./instructionRelease.vue?vue&type=script&lang=js"
export * from "./instructionRelease.vue?vue&type=script&lang=js"
import style0 from "./instructionRelease.vue?vue&type=style&index=0&id=76ae51cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ae51cf",
  null
  
)

export default component.exports